import { ref as u, onBeforeMount as X, onMounted as I, computed as c, defineComponent as P, watch as E, onUnmounted as Y, nextTick as ee, toRef as te } from "vue";
import { a as k, l as V, t as v } from "./_plugin-vue2_normalizer-VrK6B12S.mjs";
import { FileType as L, formatFileSize as ie, davRootPath as ne, davRemoteURL as se, davGetClient as H, davGetDefaultPropfind as M, getFavoriteNodes as le, davResultToNode as re, davGetRecentSearch as ae } from "@nextcloud/files";
import { getCanonicalLocale as oe } from "@nextcloud/l10n";
import { NcCheckboxRadioSwitch as O, NcDateTime as ce, NcButton as Z, NcActions as ue, NcActionInput as de, NcBreadcrumbs as fe, NcBreadcrumb as pe, NcIconSvgWrapper as _e, NcSelect as me, NcTextField as ve, NcDialog as ge, NcEmptyContent as ye } from "@nextcloud/vue";
import { loadState as j } from "@nextcloud/initial-state";
import { generateUrl as R, generateRemoteUrl as he } from "@nextcloud/router";
import { toValue as A } from "@vueuse/core";
import W from "@nextcloud/axios";
import { getCurrentUser as we } from "@nextcloud/auth";
import { Fragment as be } from "vue-frag";
import { mdiFolder as ke, mdiClock as Ce, mdiStar as Fe } from "@mdi/js";
import { emit as Se } from "@nextcloud/event-bus";
import { join as T } from "path";
import { CancelablePromise as U } from "cancelable-promise";
const $e = {
  name: "FileIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Ne = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon file-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, xe = [], Be = /* @__PURE__ */ k(
  $e,
  Ne,
  xe,
  !1,
  null,
  null,
  null,
  null
);
const G = Be.exports, D = () => {
  const l = () => document.getElementById("isPublic")?.value === "1", e = u(!0);
  return X(() => {
    e.value = l();
  }), {
    isPublic: e
  };
};
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
const K = () => {
  const l = j("files", "config", null), e = u(l?.show_hidden ?? !0), i = u(l?.sort_favorites_first ?? !0), t = u(l?.crop_image_previews ?? !0), { isPublic: n } = D();
  return I(async () => {
    if (n.value)
      console.debug("Skip loading files settings - currently on public share");
    else
      try {
        const { data: s } = await W.get(R("/apps/files/api/v1/configs"));
        e.value = s?.data?.show_hidden ?? !1, i.value = s?.data?.sort_favorites_first ?? !0, t.value = s?.data?.crop_image_previews ?? !0;
      } catch (s) {
        console.error("Could not load files settings", s), V(v("Could not load files settings"));
      }
  }), {
    showHiddenFiles: e,
    sortFavoritesFirst: i,
    cropImagePreviews: t
  };
}, Pe = (l) => {
  const e = (a) => a === "asc" ? "ascending" : a === "desc" ? "descending" : "none", i = j("files", "viewConfigs", null), t = u({
    sortBy: i?.files?.sorting_mode ?? "basename",
    order: e(i?.files?.sorting_direction ?? "asc")
  }), n = u({
    sortBy: i?.recent?.sorting_mode ?? "basename",
    order: e(i?.recent?.sorting_direction ?? "asc")
  }), s = u({
    sortBy: i?.favorites?.sorting_mode ?? "basename",
    order: e(i?.favorites?.sorting_direction ?? "asc")
  }), { isPublic: r } = D();
  I(async () => {
    if (r.value)
      console.debug("Skip loading files views - currently on public share");
    else
      try {
        const { data: a } = await W.get(R("/apps/files/api/v1/views"));
        t.value = {
          sortBy: a?.data?.files?.sorting_mode ?? "basename",
          order: e(a?.data?.files?.sorting_direction)
        }, s.value = {
          sortBy: a?.data?.favorites?.sorting_mode ?? "basename",
          order: e(a?.data?.favorites?.sorting_direction)
        }, n.value = {
          sortBy: a?.data?.recent?.sorting_mode ?? "basename",
          order: e(a?.data?.recent?.sorting_direction)
        };
      } catch (a) {
        console.error("Could not load files views", a), V(v("Could not load files views"));
      }
  });
  const b = c(() => A(l || "files") === "files" ? t.value : A(l) === "recent" ? n.value : s.value), g = c(() => b.value.sortBy), d = c(() => b.value.order);
  return {
    filesViewConfig: t,
    favoritesViewConfig: s,
    recentViewConfig: n,
    currentConfig: b,
    sortBy: g,
    order: d
  };
}, ze = {
  name: "MenuUpIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Le = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon menu-up-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M7,15L12,10L17,15H7Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, Ie = [], Ve = /* @__PURE__ */ k(
  ze,
  Le,
  Ie,
  !1,
  null,
  null,
  null,
  null
);
const Re = Ve.exports, De = {
  name: "MenuDownIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var He = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon menu-down-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M7,10L12,15L17,10H7Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, Me = [], Ae = /* @__PURE__ */ k(
  De,
  He,
  Me,
  !1,
  null,
  null,
  null,
  null
);
const Te = Ae.exports, q = {
  "file-picker__file-icon": "_file-picker__file-icon_1vgv4_5"
}, Ue = /* @__PURE__ */ P({
  __name: "LoadingTableRow",
  props: {
    showCheckbox: { type: Boolean }
  },
  setup(l) {
    return { __sfc: !0, fileListIconStyles: q };
  }
});
var Ee = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i("tr", { staticClass: "file-picker__row loading-row", attrs: { "aria-hidden": "true" } }, [e.showCheckbox ? i("td", { staticClass: "row-checkbox" }, [i("span")]) : e._e(), i("td", { staticClass: "row-name" }, [i("div", { staticClass: "row-wrapper" }, [i("span", { class: t.fileListIconStyles["file-picker__file-icon"] }), i("span")])]), e._m(0), e._m(1)]);
}, Oe = [function() {
  var l = this, e = l._self._c;
  return l._self._setupProxy, e("td", { staticClass: "row-size" }, [e("span")]);
}, function() {
  var l = this, e = l._self._c;
  return l._self._setupProxy, e("td", { staticClass: "row-modified" }, [e("span")]);
}], Ze = /* @__PURE__ */ k(
  Ue,
  Ee,
  Oe,
  !1,
  null,
  "6aded0d9",
  null,
  null
);
const je = Ze.exports;
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
function We(l, e = {}) {
  e = { size: 32, cropPreview: !1, mimeFallback: !0, ...e };
  try {
    const i = l.attributes?.previewUrl || R("/core/preview?fileId={fileid}", {
      fileid: l.fileid
    });
    let t;
    try {
      t = new URL(i);
    } catch {
      t = new URL(i, window.location.origin);
    }
    return t.searchParams.set("x", `${e.size}`), t.searchParams.set("y", `${e.size}`), t.searchParams.set("mimeFallback", `${e.mimeFallback}`), t.searchParams.set("a", e.cropPreview === !0 ? "0" : "1"), t.searchParams.set("c", `${l.attributes.etag}`), t;
  } catch {
    return null;
  }
}
const Ge = {
  name: "FolderIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Ke = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon folder-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, qe = [], Je = /* @__PURE__ */ k(
  Ge,
  Ke,
  qe,
  !1,
  null,
  null,
  null,
  null
);
const J = Je.exports, Qe = {
  name: "FilePreview"
}, Xe = /* @__PURE__ */ P({
  ...Qe,
  props: {
    node: null,
    cropImagePreviews: { type: Boolean }
  },
  setup(l) {
    const e = l, i = u(q), t = c(() => We(e.node, { cropPreview: e.cropImagePreviews })), n = c(() => e.node.type === L.File), s = u(!1);
    return E(t, () => {
      if (s.value = !1, t.value) {
        const r = document.createElement("img");
        r.src = t.value.href, r.onerror = () => r.remove(), r.onload = () => {
          s.value = !0, r.remove();
        }, document.body.appendChild(r);
      }
    }, { immediate: !0 }), { __sfc: !0, fileListIconStyles: i, props: e, previewURL: t, isFile: n, canLoadPreview: s, IconFile: G, IconFolder: J };
  }
});
var Ye = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i("div", { class: t.fileListIconStyles["file-picker__file-icon"], style: t.canLoadPreview ? { backgroundImage: `url(${t.previewURL})` } : void 0 }, [t.canLoadPreview ? e._e() : [t.isFile ? i(t.IconFile, { attrs: { size: 20 } }) : i(t.IconFolder, { attrs: { size: 20 } })]], 2);
}, et = [], tt = /* @__PURE__ */ k(
  Xe,
  Ye,
  et,
  !1,
  null,
  null,
  null,
  null
);
const it = tt.exports, nt = /* @__PURE__ */ P({
  __name: "FileListRow",
  props: {
    allowPickDirectory: { type: Boolean },
    selected: { type: Boolean },
    showCheckbox: { type: Boolean },
    canPick: { type: Boolean },
    node: null,
    cropImagePreviews: { type: Boolean }
  },
  emits: ["update:selected", "enter-directory"],
  setup(l, { emit: e }) {
    const i = l, t = c(() => i.node.attributes?.displayName || i.node.basename.slice(0, i.node.extension ? -i.node.extension.length : void 0)), n = c(() => i.node.extension), s = c(() => i.node.type === L.Folder), r = c(() => i.canPick && (i.allowPickDirectory || !s.value));
    function b() {
      e("update:selected", !i.selected);
    }
    function g() {
      s.value ? e("enter-directory", i.node) : b();
    }
    function d(a) {
      a.key === "Enter" && g();
    }
    return { __sfc: !0, props: i, emit: e, displayName: t, fileExtension: n, isDirectory: s, isPickable: r, toggleSelected: b, handleClick: g, handleKeyDown: d, formatFileSize: ie, NcCheckboxRadioSwitch: O, NcDateTime: ce, t: v, FilePreview: it };
  }
});
var st = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i("tr", e._g({ class: ["file-picker__row", {
    "file-picker__row--selected": e.selected && !e.showCheckbox
  }], attrs: { tabindex: e.showCheckbox && !t.isDirectory ? void 0 : 0, "aria-selected": t.isPickable ? e.selected : void 0, "data-filename": e.node.basename, "data-testid": "file-list-row" } }, {
    click: t.handleClick,
    /* same as tabindex -> if we hide the checkbox or this is a directory we need keyboard access to enter the directory or select the node */
    ...!e.showCheckbox || t.isDirectory ? { keydown: t.handleKeyDown } : {}
  }), [e.showCheckbox ? i("td", { staticClass: "row-checkbox", on: { click: function(n) {
    return n.stopPropagation(), (() => {
    }).apply(null, arguments);
  } } }, [i(t.NcCheckboxRadioSwitch, { attrs: { "aria-label": t.t("Select the row for {nodename}", { nodename: t.displayName }), checked: e.selected, disabled: !t.isPickable, "data-testid": "row-checkbox" }, on: { "update:checked": t.toggleSelected } })], 1) : e._e(), i("td", { staticClass: "row-name" }, [i("div", { staticClass: "file-picker__name-container", attrs: { "data-testid": "row-name" } }, [i(t.FilePreview, { attrs: { node: e.node, "crop-image-previews": e.cropImagePreviews } }), i("div", { staticClass: "file-picker__file-name", attrs: { title: t.displayName }, domProps: { textContent: e._s(t.displayName) } }), i("div", { staticClass: "file-picker__file-extension", domProps: { textContent: e._s(t.fileExtension) } })], 1)]), i("td", { staticClass: "row-size" }, [e._v(" " + e._s(t.formatFileSize(e.node.size || 0)) + " ")]), i("td", { staticClass: "row-modified" }, [i(t.NcDateTime, { attrs: { timestamp: e.node.mtime, "ignore-seconds": !0 } })], 1)]);
}, lt = [], rt = /* @__PURE__ */ k(
  nt,
  st,
  lt,
  !1,
  null,
  "48df4f27",
  null,
  null
);
const at = rt.exports, ot = /* @__PURE__ */ P({
  __name: "FileList",
  props: {
    currentView: null,
    multiselect: { type: Boolean },
    allowPickDirectory: { type: Boolean },
    loading: { type: Boolean },
    files: null,
    selectedFiles: null,
    path: null
  },
  emits: ["update:path", "update:selectedFiles"],
  setup(l, { emit: e }) {
    const i = l, t = u(), { currentConfig: n } = Pe(i.currentView), s = c(() => t.value ?? n.value), r = c(() => s.value.sortBy === "basename" ? s.value.order === "none" ? void 0 : s.value.order : void 0), b = c(() => s.value.sortBy === "size" ? s.value.order === "none" ? void 0 : s.value.order : void 0), g = c(() => s.value.sortBy === "mtime" ? s.value.order === "none" ? void 0 : s.value.order : void 0), d = (o) => {
      s.value.sortBy === o ? s.value.order === "ascending" ? t.value = { sortBy: s.value.sortBy, order: "descending" } : t.value = { sortBy: s.value.sortBy, order: "ascending" } : t.value = { sortBy: o, order: "ascending" };
    }, { sortFavoritesFirst: a, cropImagePreviews: p } = K(), B = c(
      () => {
        const o = {
          ascending: (m, f, z) => z(m, f),
          descending: (m, f, z) => z(f, m),
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          none: (m, f, z) => 0
        }, C = {
          basename: (m, f) => (m.attributes?.displayName || m.basename).localeCompare(f.attributes?.displayName || f.basename, oe()),
          size: (m, f) => (m.size || 0) - (f.size || 0),
          // reverted because "young" is smaller than "old"
          mtime: (m, f) => (f.mtime?.getTime?.() || 0) - (m.mtime?.getTime?.() || 0)
        };
        return [...i.files].sort(
          (m, f) => (
            // Folders always come above the files
            (f.type === L.Folder ? 1 : 0) - (m.type === L.Folder ? 1 : 0) || (a ? (f.attributes.favorite ? 1 : 0) - (m.attributes.favorite ? 1 : 0) : 0) || o[s.value.order](m, f, C[s.value.sortBy])
          )
        );
      }
    ), F = c(() => i.files.filter((o) => i.allowPickDirectory || o.type !== L.Folder)), N = c(() => !i.loading && i.selectedFiles.length > 0 && i.selectedFiles.length >= F.value.length);
    function h() {
      i.selectedFiles.length < F.value.length ? e("update:selectedFiles", F.value) : e("update:selectedFiles", []);
    }
    function w(o) {
      i.selectedFiles.includes(o) ? e("update:selectedFiles", i.selectedFiles.filter((C) => C.path !== o.path)) : i.multiselect ? e("update:selectedFiles", [...i.selectedFiles, o]) : e("update:selectedFiles", [o]);
    }
    function S(o) {
      e("update:path", o.path);
    }
    const x = u(4), $ = u();
    {
      const o = () => ee(() => {
        const C = $.value?.parentElement?.children || [];
        let m = $.value?.parentElement?.clientHeight || 450;
        for (let f = 0; f < C.length; f++)
          $.value?.isSameNode(C[f]) || (m -= C[f].clientHeight);
        x.value = Math.floor((m - 50) / 50);
      });
      I(() => {
        window.addEventListener("resize", o), o();
      }), Y(() => {
        window.removeEventListener("resize", o);
      });
    }
    return { __sfc: !0, props: i, emit: e, customSortingConfig: t, filesAppSorting: n, sortingConfig: s, sortByName: r, sortBySize: b, sortByModified: g, toggleSorting: d, sortFavoritesFirst: a, cropImagePreviews: p, sortedFiles: B, selectableFiles: F, allSelected: N, onSelectAll: h, onNodeSelected: w, onChangeDirectory: S, skeletonNumber: x, fileContainer: $, NcButton: Z, NcCheckboxRadioSwitch: O, t: v, IconSortAscending: Re, IconSortDescending: Te, LoadingTableRow: je, FileListRow: at };
  }
});
var ct = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i("div", { ref: "fileContainer", staticClass: "file-picker__files" }, [i("table", [i("thead", [i("tr", [e.multiselect ? i("th", { staticClass: "row-checkbox" }, [i("span", { staticClass: "hidden-visually" }, [e._v(" " + e._s(t.t("Select entry")) + " ")]), e.multiselect ? i(t.NcCheckboxRadioSwitch, { attrs: { "aria-label": t.t("Select all entries"), checked: t.allSelected, "data-testid": "select-all-checkbox" }, on: { "update:checked": t.onSelectAll } }) : e._e()], 1) : e._e(), i("th", { staticClass: "row-name", attrs: { "aria-sort": t.sortByName } }, [i("div", { staticClass: "header-wrapper" }, [i("span", { staticClass: "file-picker__header-preview" }), i(t.NcButton, { attrs: { wide: !0, type: "tertiary", "data-test": "file-picker_sort-name" }, on: { click: function(n) {
    return t.toggleSorting("basename");
  } }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t.sortByName === "ascending" ? i(t.IconSortAscending, { attrs: { size: 20 } }) : t.sortByName === "descending" ? i(t.IconSortDescending, { attrs: { size: 20 } }) : i("span", { staticStyle: { width: "44px" } })];
  }, proxy: !0 }]) }, [e._v(" " + e._s(t.t("Name")) + " ")])], 1)]), i("th", { staticClass: "row-size", attrs: { "aria-sort": t.sortBySize } }, [i(t.NcButton, { attrs: { wide: !0, type: "tertiary" }, on: { click: function(n) {
    return t.toggleSorting("size");
  } }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t.sortBySize === "ascending" ? i(t.IconSortAscending, { attrs: { size: 20 } }) : t.sortBySize === "descending" ? i(t.IconSortDescending, { attrs: { size: 20 } }) : i("span", { staticStyle: { width: "44px" } })];
  }, proxy: !0 }]) }, [e._v(" " + e._s(t.t("Size")) + " ")])], 1), i("th", { staticClass: "row-modified", attrs: { "aria-sort": t.sortByModified } }, [i(t.NcButton, { attrs: { wide: !0, type: "tertiary" }, on: { click: function(n) {
    return t.toggleSorting("mtime");
  } }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t.sortByModified === "ascending" ? i(t.IconSortAscending, { attrs: { size: 20 } }) : t.sortByModified === "descending" ? i(t.IconSortDescending, { attrs: { size: 20 } }) : i("span", { staticStyle: { width: "44px" } })];
  }, proxy: !0 }]) }, [e._v(" " + e._s(t.t("Modified")) + " ")])], 1)])]), i("tbody", [e.loading ? e._l(t.skeletonNumber, function(n) {
    return i(t.LoadingTableRow, { key: n, attrs: { "show-checkbox": e.multiselect } });
  }) : e._l(t.sortedFiles, function(n) {
    return i(t.FileListRow, { key: n.fileid || n.path, attrs: { "allow-pick-directory": e.allowPickDirectory, "show-checkbox": e.multiselect, "can-pick": e.multiselect || e.selectedFiles.length === 0 || e.selectedFiles.includes(n), selected: e.selectedFiles.includes(n), node: n, "crop-image-previews": t.cropImagePreviews }, on: { "update:selected": function(s) {
      return t.onNodeSelected(n);
    }, "enter-directory": t.onChangeDirectory } });
  })], 2)])]);
}, ut = [], dt = /* @__PURE__ */ k(
  ot,
  ct,
  ut,
  !1,
  null,
  "d3c94818",
  null,
  null
);
const ft = dt.exports, pt = {
  name: "HomeIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var _t = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon home-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, mt = [], vt = /* @__PURE__ */ k(
  pt,
  _t,
  mt,
  !1,
  null,
  null,
  null,
  null
);
const gt = vt.exports, yt = {
  name: "PlusIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var ht = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon plus-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, wt = [], bt = /* @__PURE__ */ k(
  yt,
  ht,
  wt,
  !1,
  null,
  null,
  null,
  null
);
const kt = bt.exports, Ct = /* @__PURE__ */ P({
  __name: "FilePickerBreadcrumbs",
  props: {
    path: null,
    showMenu: { type: Boolean }
  },
  emits: ["update:path", "create-node"],
  setup(l, { emit: e }) {
    const i = l, t = u(!1), n = u(""), s = u();
    function r() {
      const d = n.value.trim(), a = s.value?.$el?.querySelector("input");
      let p = "";
      return d.length === 0 ? p = v("Folder name cannot be empty.") : d.includes("/") ? p = v('"/" is not allowed inside a folder name.') : ["..", "."].includes(d) ? p = v('"{name}" is an invalid folder name.', { name: d }) : window.OC.config?.blacklist_files_regex && d.match(window.OC.config?.blacklist_files_regex) && (p = v('"{name}" is not an allowed folder name', { name: d })), a && a.setCustomValidity(p), p === "";
    }
    const b = function() {
      const d = n.value.trim();
      r() && (t.value = !1, e("create-node", d), n.value = "");
    }, g = c(
      () => i.path.split("/").filter((d) => d !== "").map((d, a, p) => ({
        name: d,
        path: "/" + p.slice(0, a + 1).join("/")
      }))
    );
    return { __sfc: !0, props: i, emit: e, actionsOpen: t, newNodeName: n, nameInput: s, validateInput: r, onSubmit: b, pathElements: g, IconFolder: J, IconHome: gt, IconPlus: kt, NcActions: ue, NcActionInput: de, NcBreadcrumbs: fe, NcBreadcrumb: pe, t: v };
  }
});
var Ft = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i(t.NcBreadcrumbs, { staticClass: "file-picker__breadcrumbs", scopedSlots: e._u([{ key: "default", fn: function() {
    return [i(t.NcBreadcrumb, { attrs: { name: t.t("All files"), title: t.t("Home") }, on: { click: function(n) {
      return t.emit("update:path", "/");
    } }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [i(t.IconHome, { attrs: { size: 20 } })];
    }, proxy: !0 }]) }), e._l(t.pathElements, function(n) {
      return i(t.NcBreadcrumb, { key: n.path, attrs: { name: n.name, title: n.path }, on: { click: function(s) {
        return t.emit("update:path", n.path);
      } } });
    })];
  }, proxy: !0 }, e.showMenu ? { key: "actions", fn: function() {
    return [i(t.NcActions, { attrs: { "aria-label": t.t("Create directory"), "force-menu": !0, "force-name": !0, "menu-name": t.t("New"), open: t.actionsOpen, type: "secondary" }, on: { "update:open": function(n) {
      t.actionsOpen = n;
    }, close: function(n) {
      t.newNodeName = "";
    } }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [i(t.IconPlus, { attrs: { size: 20 } })];
    }, proxy: !0 }], null, !1, 2971667417) }, [i(t.NcActionInput, { ref: "nameInput", attrs: { value: t.newNodeName, label: t.t("New folder"), placeholder: t.t("New folder name") }, on: { "update:value": function(n) {
      t.newNodeName = n;
    }, submit: t.onSubmit, input: t.validateInput }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [i(t.IconFolder, { attrs: { size: 20 } })];
    }, proxy: !0 }], null, !1, 1614167509) })], 1)];
  }, proxy: !0 } : null], null, !0) });
}, St = [], $t = /* @__PURE__ */ k(
  Ct,
  Ft,
  St,
  !1,
  null,
  "22cbb5df",
  null,
  null
);
const Nt = $t.exports, xt = {
  name: "CloseIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Bt = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon close-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, Pt = [], zt = /* @__PURE__ */ k(
  xt,
  Bt,
  Pt,
  !1,
  null,
  null,
  null,
  null
);
const Lt = zt.exports, It = {
  name: "MagnifyIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Vt = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon magnify-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, Rt = [], Dt = /* @__PURE__ */ k(
  It,
  Vt,
  Rt,
  !1,
  null,
  null,
  null,
  null
);
const Ht = Dt.exports;
/**
 * @copyright Copyright (c) 2024 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
const Mt = (l) => {
  const e = [
    {
      id: "files",
      label: v("All files"),
      icon: ke
    },
    {
      id: "recent",
      label: v("Recent"),
      icon: Ce
    },
    {
      id: "favorites",
      label: v("Favorites"),
      icon: Fe
    }
  ], i = l.value ? e.filter(({ id: t }) => t === "files") : e;
  return {
    allViews: e,
    availableViews: i
  };
}, At = /* @__PURE__ */ P({
  __name: "FilePickerNavigation",
  props: {
    currentView: null,
    filterString: null,
    isCollapsed: { type: Boolean },
    disabledNavigation: { type: Boolean }
  },
  emits: ["update:currentView", "update:filterString"],
  setup(l, { emit: e }) {
    const i = l, { availableViews: t } = Mt(u(we() === null)), n = c(() => t.filter((r) => r.id === i.currentView)[0] ?? t[0]);
    return { __sfc: !0, props: i, emit: e, availableViews: t, currentViewObject: n, updateFilterValue: (r) => e("update:filterString", r), IconClose: Lt, IconMagnify: Ht, NcButton: Z, NcIconSvgWrapper: _e, NcSelect: me, NcTextField: ve, Fragment: be, t: v };
  }
});
var Tt = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i(t.Fragment, [i(t.NcTextField, { staticClass: "file-picker__filter-input", attrs: { value: e.filterString, label: t.t("Filter file list"), "show-trailing-button": !!e.filterString }, on: { "update:value": t.updateFilterValue, "trailing-button-click": function(n) {
    return t.updateFilterValue("");
  } }, scopedSlots: e._u([{ key: "trailing-button-icon", fn: function() {
    return [i(t.IconClose, { attrs: { size: 16 } })];
  }, proxy: !0 }]) }, [i(t.IconMagnify, { attrs: { size: 16 } })], 1), t.availableViews.length > 1 && !e.disabledNavigation ? [e.isCollapsed ? i(t.NcSelect, { attrs: { "aria-label": t.t("Current view selector"), clearable: !1, searchable: !1, options: t.availableViews, value: t.currentViewObject }, on: { input: (n) => t.emit("update:currentView", n.id) } }) : i("ul", { staticClass: "file-picker__side" }, e._l(t.availableViews, function(n) {
    return i("li", { key: n.id }, [i(t.NcButton, { attrs: { type: e.currentView === n.id ? "primary" : "tertiary", wide: !0 }, on: { click: function(s) {
      return e.$emit("update:currentView", n.id);
    } }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [i(t.NcIconSvgWrapper, { attrs: { path: n.icon, size: 20 } })];
    }, proxy: !0 }], null, !0) }, [e._v(" " + e._s(n.label) + " ")])], 1);
  }), 0)] : e._e()], 2);
}, Ut = [], Et = /* @__PURE__ */ k(
  At,
  Tt,
  Ut,
  !1,
  null,
  "a06474d4",
  null,
  null
);
const Ot = Et.exports;
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const Zt = function(l, e, i) {
  const t = c(() => i.value ? "/" : ne), n = c(() => i.value ? he("webdav").replace("/remote.php", "/public.php") : se), s = c(() => {
    if (i.value) {
      const h = document.getElementById("sharingToken").value, w = btoa(`${h}:null`);
      return H(n.value, {
        Authorization: `Basic ${w}`
      });
    }
    return H();
  }), r = (h) => re(h, t.value, n.value), b = () => {
    const h = new AbortController(), w = Math.round(Date.now() / 1e3) - 60 * 60 * 24 * 14;
    return new U(async (S, x, $) => {
      $(() => h.abort());
      try {
        const { data: o } = await s.value.search("/", {
          signal: h.signal,
          details: !0,
          data: ae(w)
        }), C = o.results.map(r);
        S(C);
      } catch (o) {
        x(o);
      }
    });
  }, g = () => {
    const h = new AbortController();
    return new U(async (w, S, x) => {
      x(() => h.abort());
      try {
        let o = (await s.value.getDirectoryContents(`${t.value}${e.value}`, {
          signal: h.signal,
          details: !0,
          data: M()
        })).data.map(r);
        i.value && (o = o.filter((C) => C.path !== e.value)), w(o);
      } catch ($) {
        S($);
      }
    });
  }, d = u([]), a = u(!0), p = u(null);
  async function B(h) {
    const w = T(e.value, h);
    await s.value.createDirectory(T(t.value, w));
    const S = await F(w);
    return d.value.push(S), S;
  }
  async function F(h, w = void 0) {
    w = w ?? t.value;
    const { data: S } = await s.value.stat(`${w}${h}`, {
      details: !0,
      data: M()
    });
    return r(S);
  }
  async function N() {
    p.value && p.value.cancel(), a.value = !0, l.value === "favorites" ? p.value = le(s.value, e.value, t.value) : l.value === "recent" ? p.value = b() : p.value = g(), d.value = await p.value, p.value = null, a.value = !1;
  }
  return E([l, e], () => N()), I(() => N()), {
    isLoading: a,
    files: d,
    loadFiles: N,
    getFile: F,
    createDirectory: B
  };
};
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const jt = function(l) {
  const e = c(() => l.value.map((t) => t.split("/")));
  return {
    isSupportedMimeType: (t) => {
      const n = t.split("/");
      return e.value.some(
        ([s, r]) => (
          // check mime type matches or is wildcard
          (n[0] === s || s === "*") && (n[1] === r || r === "*")
        )
      );
    }
  };
}, Wt = {
  name: "FilePicker"
}, Gt = /* @__PURE__ */ P({
  ...Wt,
  props: {
    buttons: null,
    name: null,
    allowPickDirectory: { type: Boolean, default: !1 },
    disabledNavigation: { type: Boolean, default: !1 },
    container: { default: "body" },
    filterFn: { default: void 0 },
    mimetypeFilter: { default: () => [] },
    multiselect: { type: Boolean, default: !0 },
    path: { default: void 0 }
  },
  emits: ["close"],
  setup(l, { emit: e }) {
    const i = l, { isPublic: t } = D(), n = u(!0), s = c(() => (typeof i.buttons == "function" ? i.buttons(a.value, F.value, g.value) : i.buttons).map((y) => ({
      ...y,
      callback: () => {
        r = !0, b(y.callback);
      }
    })));
    let r = !1;
    const b = async (_) => {
      const y = a.value.length === 0 && i.allowPickDirectory ? [await $(F.value)] : a.value;
      _(y), e("close", y), r = !1;
    }, g = u("files"), d = c(() => g.value === "favorites" ? v("Favorites") : g.value === "recent" ? v("Recent") : ""), a = u([]), p = u(window?.sessionStorage.getItem("NC.FilePicker.LastPath") || "/"), B = u(), F = c({
      // Only use the path for the files view as favorites and recent only works on the root
      get: () => g.value === "files" ? B.value || i.path || p.value : "/",
      /**
       * Navigate to the new path and save it to the session storage
       *
       * @param path The new path
       */
      set: (_) => {
        i.path === void 0 && window.sessionStorage.setItem("NC.FilePicker.LastPath", _), B.value = _, a.value = [];
      }
    }), N = u(""), { isSupportedMimeType: h } = jt(te(i, "mimetypeFilter")), { files: w, isLoading: S, loadFiles: x, getFile: $, createDirectory: o } = Zt(g, F, t);
    I(() => x());
    const { showHiddenFiles: C } = K(), m = c(() => {
      let _ = w.value;
      return C.value || (_ = _.filter((y) => !y.basename.startsWith("."))), i.mimetypeFilter.length > 0 && (_ = _.filter((y) => y.type === "folder" || y.mime && h(y.mime))), N.value && (_ = _.filter((y) => y.basename.toLowerCase().includes(N.value.toLowerCase()))), i.filterFn && (_ = _.filter((y) => i.filterFn(y))), _;
    }), f = c(() => g.value === "files" ? v("Upload some content or sync with your devices!") : g.value === "recent" ? v("Files and folders you recently modified will show up here.") : v("Files and folders you mark as favorite will show up here."));
    return { __sfc: !0, props: i, emit: e, isPublic: t, isOpen: n, dialogButtons: s, isHandlingCallback: r, handleButtonClick: b, currentView: g, viewHeadline: d, selectedFiles: a, savedPath: p, navigatedPath: B, currentPath: F, filterString: N, isSupportedMimeType: h, files: w, isLoading: S, loadFiles: x, getFile: $, createDirectory: o, showHiddenFiles: C, filteredFiles: m, noFilesDescription: f, onCreateFolder: async (_) => {
      try {
        const y = await o(_);
        F.value = y.path, Se("files:node:created", w.value.filter((Q) => Q.basename === _)[0]);
      } catch (y) {
        console.warn("Could not create new folder", { name: _, error: y }), V(v("Could not create the new folder"));
      }
    }, handleClose: (_) => {
      !_ && !r && e("close");
    }, IconFile: G, FileList: ft, FilePickerBreadcrumbs: Nt, FilePickerNavigation: Ot, NcDialog: ge, NcEmptyContent: ye, t: v };
  }
});
var Kt = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i(t.NcDialog, { attrs: { container: e.container, buttons: t.dialogButtons, name: e.name, size: "large", "content-classes": "file-picker__content", "dialog-classes": "file-picker", "navigation-classes": "file-picker__navigation", open: t.isOpen }, on: { "update:open": [function(n) {
    t.isOpen = n;
  }, t.handleClose] }, scopedSlots: e._u([{ key: "navigation", fn: function({ isCollapsed: n }) {
    return [i(t.FilePickerNavigation, { attrs: { "is-collapsed": n, "current-view": t.currentView, "filter-string": t.filterString, "disabled-navigation": e.disabledNavigation }, on: { "update:currentView": function(s) {
      t.currentView = s;
    }, "update:current-view": function(s) {
      t.currentView = s;
    }, "update:filterString": function(s) {
      t.filterString = s;
    }, "update:filter-string": function(s) {
      t.filterString = s;
    } } })];
  } }]) }, [i("div", { staticClass: "file-picker__main" }, [t.currentView === "files" ? i(t.FilePickerBreadcrumbs, { attrs: { path: t.currentPath, "show-menu": e.allowPickDirectory }, on: { "update:path": function(n) {
    t.currentPath = n;
  }, "create-node": t.onCreateFolder } }) : i("div", { staticClass: "file-picker__view" }, [i("h3", [e._v(e._s(t.viewHeadline))])]), t.isLoading || t.filteredFiles.length > 0 ? i(t.FileList, { attrs: { "allow-pick-directory": e.allowPickDirectory, "current-view": t.currentView, files: t.filteredFiles, multiselect: e.multiselect, loading: t.isLoading, path: t.currentPath, "selected-files": t.selectedFiles, name: t.viewHeadline }, on: { "update:path": [function(n) {
    t.currentPath = n;
  }, function(n) {
    t.currentView = "files";
  }], "update:selectedFiles": function(n) {
    t.selectedFiles = n;
  }, "update:selected-files": function(n) {
    t.selectedFiles = n;
  } } }) : t.filterString ? i(t.NcEmptyContent, { attrs: { name: t.t("No matching files"), description: t.t("No files matching your filter were found.") }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [i(t.IconFile)];
  }, proxy: !0 }]) }) : i(t.NcEmptyContent, { attrs: { name: t.t("No files in here"), description: t.noFilesDescription }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [i(t.IconFile)];
  }, proxy: !0 }]) })], 1)]);
}, qt = [], Jt = /* @__PURE__ */ k(
  Gt,
  Kt,
  qt,
  !1,
  null,
  "6ff1b36b",
  null,
  null
);
const pi = Jt.exports;
export {
  pi as default
};
